<template>
  <h1>Payments Component</h1>
</template>

<script lang="ts" setup></script>
